import './Footer.css'
import { Link, useLocation } from "react-router-dom";
import React, { useEffect } from "react";


function Footer() {

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const el = document.querySelector(location.hash);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: 'smooth' });
                }, 50);
            }
        }
    }, [location]);

    return (
        <footer className='footer'>
            <div className='footer__top'>
                <div className='footer__brand'>
                    <img className='footer__logo' src='/img/drontalia3.png' alt='Drontalia' />
                </div>

                <div className='footer__col'>
                    <span className='footer__eyebrow'>NAVEGACIÓN</span>
                    <a className='footer__link' onClick={() => window.location.href = "/#inicio"}>Inicio</a>
                    <a className='footer__link' onClick={() => window.location.href = "/#servicios"}>Servicios</a>
                    <a className='footer__link' onClick={() => window.location.href = "/#contacto"}>Contacto</a>
                </div>

                <div className='footer__col'>
                    <span className='footer__eyebrow'>LEGAL</span>
                    <Link className='footer__link' to='/aviso-legal'>Aviso Legal</Link>
                    <Link className='footer__link' to='/politica-privacidad'>Política de privacidad</Link>
                    <Link className='footer__link' to='/politica-cookies'>Política de cookies</Link>
                </div>
            </div>

            <div className='footer__bottom'>
                <p>© 2026 Drontalia · Powered by Antonio Guerrero</p>
            </div>
        </footer>
    )
}

export default Footer
